import React, {useEffect, useState} from 'react'
import Layout from '../../../components/layout/Layout'
import OtpInput from 'react-otp-input';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from 'react-router-dom';
import {sendData} from "../../../store/actions";
import useSocket from "../../common/useSocket";
import {showToastSuccess} from "ubs-framework/v2/common/function";
import 'react-toastify/dist/ReactToastify.css';
import AppHeader from "../../common/components/app-header";
import * as Icon from "ubs-icons";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function verifyOrganization() {
    const history = useHistory();
    const dispatch = useDispatch()
    const _EMAIL = useSelector(e => e.common?.email)
    const [otp, setOTP] = useState('');
    const [errorMsg, setErrorMsg] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);
    const {id} = useParams()

    const {on, off, refresh} = useSocket(res => {
        setDisableBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'resendOTP':
                    showToastSuccess("OTP sent successfully.")
                    break;
                case 'activateOrganization':
                    history.push("/workspace")
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    useEffect(() => {
        on();
        return () => off()
    }, [])

    const changeOTP = otp => {
        setOTP(otp)
    }
    const verify = () => {
        setDisableBtn(true)
        sendData(dispatch, 'activateOrganization', {otp: otp, orgId: id});
    }
    const resendOTP = () => {
        sendData(dispatch, 'resendOTP', {email: _EMAIL});
    }
    return (
        <React.Fragment>
            <Layout>
                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Verify Your Email" title={`We’ve sent you a six digit verification OTP at <span>${_EMAIL?.email}</span>`}/>
                    <div className={`u_otp ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                        <OtpInput
                            value={otp}
                            onChange={changeOTP}
                            isInputNum={true}
                            containerStyle={'u_otp-container'}
                            inputStyle={'u_otp-input'}
                            numInputs={6}
                            shouldAutoFocus={true}
                            separator={<span> </span>}
                        />
                    </div>

                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_block u_relative">
                        <button
                            disabled={disableBtn}
                            type="button"
                            onClick={verify}
                            className={`u_account-btn u_w-full u_cp`}
                            data-testid={TEST_ID.VERIFY_ORGANIZATION.SUBMIT_BUTTON}>Submit </button>
                        {
                            disableBtn &&
                            <div className="u_btn-loader"><Icon.Preloader size={70} /></div>
                        }
                    </div>

                    <p className="u_send-code u_t-center u_mt-20">Didn’t receive the OTP ? <span className="u_cp" onClick={resendOTP} data-testid={TEST_ID.VERIFY_ORGANIZATION.RESEND_OTP_LINK} >Resend OTP</span>
                    </p>
                </div>
            </Layout>
        </React.Fragment>
    );
}


export default verifyOrganization

